import { Component } from '@angular/core';

@Component({
  selector: 'app-cards1-examples-4',
  templateUrl: './cards1-examples-4.component.html'
})
export class Cards1Examples4Component {}
